/**
 * Created by roi on 27/02/17.
 */
import React, { Component } from 'react';

class Contacte extends Component {

    render() {
        return <div>Contacte</div>;
    }
}

export default Contacte;



// WEBPACK FOOTER //
// ./src/components/contacte.js